import type { Navigation } from '@/models/navigation'

export const SOURCE_NAVIGATION: Navigation = [
  { href: '/', name: 'Home' },
  {
    href: '/category/critical-minerals',
    name: 'Critical Minerals',
  },
  {
    href: '/category/batteries',
    name: 'Batteries',
  },
  {
    href: '/category/sustainability',
    name: 'Sustainability',
  },
  {
    href: '/category/new-energy',
    name: 'New Energy',
  },
  {
    href: '/category/geopolitics',
    name: 'Geopolitics',
  },
  {
    href: '/data-visualisation',
    name: 'Data Visualisation',
  },
  {
    href: '/video',
    name: 'Video',
    variant: 'secondary',
  },
  {
    href: '/publications',
    name: 'Publications',
    variant: 'secondary',
    children: [
      {
        href: '/publications/briefings',
        name: 'Briefings',
        root: true,
      },
      {
        href: '/publications/special-issues',
        name: 'Special Issues',
      },
      {
        href: '/publications/presentations',
        name: 'Presentations',
      },
      { href: '/publications/magazine', name: 'Magazine Archive' },
    ],
  },
  {
    href: '/newsletter',
    name: 'Newsletter',
    variant: 'secondary',
  },
]
